import type { FaireProductEntity } from "../../entity_types/product";

export const p_w7kegspk42: FaireProductEntity = {
  token: "p_w7kegspk42",
  type: "product",
  name: "Connemara Candle",
  brandToken: "b_4qoo1h9y",
  brandName: "Sonder Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/fc16408b744acde354d7d67cbb917f7cc9910a2a09c503fac763f2dce0cc6e84.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68801e000eb85e55cfef59603af699cb1a716068434398d8ac702f9cde63e97e.png",
    "https://cdn.faire.com/fastly/7909bad99572e7969b39466efda053b94bec7aada8474b87abcb42a845571a32.png",
    "https://cdn.faire.com/fastly/1a0869963a0df3950bc901412932e911737f240396ca8fea86c3e97916a65a96.png",
  ],
  priceDollars: 24,
  description:
    "8 oz\n\nNutmeg | Lemon | Pachouli\n\nConnemara is named after a quaint town in Ireland.\n\nMade with soy wax and hand-poured in amber glass in St. Louis, MO\n\nAfter you have fully enjoyed your candle, your vessel was designed to transition into your favorite drinking glass! It's heat-resistant and ready for both hot and cold beverages. Additionally, its microwave-safe and dishwasher-friendly, too.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:51.752Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
